import { CompactType, DisplayGrid, GridType } from 'angular-gridster2'
import {
  Draggable,
  GridsterConfig as GConfig,
  PushDirections,
  Resizable
} from 'angular-gridster2'

export interface GridsterConfig extends GConfig {
  draggable: Draggable;
  resizable: Resizable;
  pushDirections: PushDirections;
}

const config: GridsterConfig = {
  gridType: GridType.ScrollVertical,
  DisplayGrid: DisplayGrid.Always,
  // CompactUp, not None. pushItem() used to flip this to CompactUp and push it in
  // with options.api.optionsChanged(), and because that wrote the grid's own options
  // the flip stuck for the rest of the session - so from the first widget resize
  // onwards the grid always ran compacted. Gridster 21 removed that api, the flip
  // stopped landing, and checkCompact() has been returning early ever since, leaving
  // every vertical gap in the saved desktop layout in place and the canvas as tall as
  // its bottom-most tile. Setting it here restores the compacted steady state, and
  // from the first layout rather than from the first resize.
  compactType: CompactType.CompactUp,
  pushItems: true,
  outerMargin: true,
  margin:4,
  minCols: 50,
  maxCols: 200,
  minRows: 25,
  maxRows: 2000,
  minItemCols: 1,
  minItemRows: 1,
  maxItemCols: 200,
  maxItemRows: 2000,
  maxItemArea: 400000,
  minItemArea: 1,
  defaultItemCols: 1,
  defaultItemRows: 1,
  enableEmptyCellClick: false,
  enableEmptyCellContextMenu: false,
  enableEmptyCellDrop: false,
  enableEmptyCellDrag: false,
  enableOccupiedCellDrop: false,
  emptyCellDragMaxCols: 10,
  emptyCellDragMaxRows: 5,
  ignoreMarginInRow: false,
  draggable: {
    enabled: false,
  },
  resizable: {
    enabled: false,
  },
  pushDirections: { north: true, east: true, west: true, south: true },
}

export default config